// Anchor and section-navigation helpers for canonical content.
// Anchor helpers for canonical section trees.

import type { Section } from '@airhead-games/shared/content';

export const DOCUMENT_SECTION_NAVIGATION_EVENT =
  'airhead-document-section:navigate';

export interface DocumentSectionNavigationDetail {
  id: string;
}

export const collectSectionIds = (sections: Section[]): string[] =>
  sections.flatMap((section) => [
    section.id,
    ...(section.sections ? collectSectionIds(section.sections) : []),
  ]);

export const sectionTreeContainsId = (section: Section, id: string): boolean =>
  section.id === id ||
  Boolean(section.sections?.some((child) => sectionTreeContainsId(child, id)));

export const dispatchDocumentSectionNavigation = (id: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<DocumentSectionNavigationDetail>(
      DOCUMENT_SECTION_NAVIGATION_EVENT,
      {
        detail: { id },
      }
    )
  );
};
